import { Link } from "react-router";
import { PILLARS } from "./data";

export const PillarsSection = () => {
  return (
    <section className="diff-section">
      <div className="fi" style={{ maxWidth: "660px" }}>
        <div className="ey">Why Home Design Guild</div>
        <h2 className="st">
          Built for homeowners who take
          <br className="pillars-title-break" />
          their home <em>seriously.</em>
        </h2>
        <p className="lead">
          Searching "interior designers near me" shouldn't mean hours of
          scrolling unverified profiles. Home Design Guild is the only platform
          that eliminates the guesswork — delivering a curated match with a
          top, HDG authorized interior designer based on who you are, not just
          what you want.
        </p>
      </div>

      <div className="diff-grid fi">
        {PILLARS.map((pillar) => (
          <article className="dc" key={pillar.id}>
            <div className="dc-n">{pillar.id}</div>
            <div className="dc-bar" />
            <h3 className="dc-t">{pillar.title}</h3>
            <p className="dc-b">{pillar.body}</p>
            <Link to={pillar.href} className="lnk-rose">
              {pillar.cta} →
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
};
